import { useNavigation } from "@react-navigation/native";
import { HStack } from "@towersystems/roam-common-native";
import { Button } from "@towersystems/roam-common-native";
import { useEditTile } from "../../../../../../utilities/layout";
import { Colors, View } from "react-native-ui-lib";
import { useFormContext } from "react-hook-form";
import { useSetupAllStartupEntities } from "../../../../../../utilities/setup";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";

export interface EditTileFooterProps {
  id: string;
}

export function EditFilterDeleteFooter({ id }: EditTileFooterProps) {
  const { handleRemoveTile } = useEditTile();
  const navigation = useNavigation<any>();

  return (
    <HStack>
      <View flex>
        <Button
          style={{ flexGrow: 1 }}
          isDestructive
          onPress={() => handleRemoveTile(id)}
          label="Remove Tile"
        ></Button>
      </View>
      <View flex>
        <Button
          style={{ flexGrow: 1 }}
          onPress={() => navigation.goBack()}
          isAction
          label="Return to Sell Screen"
        ></Button>
      </View>
    </HStack>
  );
}

export function EditTileFooter({ id }: EditTileFooterProps) {
  const navigation = useNavigation<any>();
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const { handleRemoveTile, handleUpdateTile } = useEditTile();
  const {
    handleSubmit,
    formState: { isDirty, isValid, isSubmitting },
  } = useFormContext<any>();

  // this original code is janky and confusing - needs to be refactored properly
  // it does not support updating local values that differ from the server without
  // significant changes to the useEditTile hook.
  // For example uploading an image and updating the image URL locally before saving is not possible
  // It also seems to cause errors if the server fails to respond correctly

  // After save, reload the tile data from server to ensure consistency
  const updateTile = async (values: LayoutNodeInput) => {
    return handleUpdateTile(values).then(async () => {
      // reload tile data from server here
      await fetchAndSyncEntity("layout_nodes");
      await fetchAndSyncEntity("layouts");
    });
  };

  return isDirty ? (
    <Button
      label={"Save"}
      backgroundColor={Colors.action}
      color="white"
      disabled={!isValid || isSubmitting}
      onPress={handleSubmit(updateTile, console.log)}
    ></Button>
  ) : (
    <HStack>
      <View flex>
        <Button
          style={{ flexGrow: 1 }}
          isDestructive
          onPress={() => handleRemoveTile(id)}
          disabled={isSubmitting}
          label="Remove Tile"
        ></Button>
      </View>
      <View flex>
        <Button
          style={{ flexGrow: 1 }}
          onPress={() => navigation.goBack()}
          isAction
          label="Return to Sell Screen"
        ></Button>
      </View>
    </HStack>
  );
}
